var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/isarray@1.0.0/~/isarray/index.js
// module id = 217
// module chunks = 1